export type DataManifest = { schema: 1; files: Record<string, string> };

export function parseDataManifest(value: unknown): DataManifest | null {
  if (!value || typeof value !== 'object') return null;
  const candidate = value as Partial<DataManifest>;
  if (candidate.schema !== 1 || !candidate.files || typeof candidate.files !== 'object') return null;
  const files: Record<string, string> = {};
  for (const [path, hash] of Object.entries(candidate.files)) {
    if (!/^\/data\/[a-zA-Z0-9_-]+\.(csv|json|xls|xlsx|csv\.gz)$/.test(path) || !/^[a-f0-9]{64}$/.test(hash)) return null;
    files[path] = hash;
  }
  return { schema: 1, files };
}

export async function verifiedDataResponse(bytes: Uint8Array, hash: string, path: string): Promise<Response | null> {
  const digest = await crypto.subtle.digest('SHA-256', bytes.slice().buffer);
  const actual = Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
  if (actual !== hash) return null;
  const type = path.endsWith('.json') ? 'application/json' : path.endsWith('.csv') ? 'text/csv; charset=utf-8' : 'application/octet-stream';
  return new Response(bytes.slice().buffer, { headers: { 'Content-Type': type } });
}